import { render } from "./OtherPaiementDeleted.vue?vue&type=template&id=24805701&scoped=true"
import script from "./OtherPaiementDeleted.vue?vue&type=script&lang=js"
export * from "./OtherPaiementDeleted.vue?vue&type=script&lang=js"

import "./OtherPaiementDeleted.vue?vue&type=style&index=0&id=24805701&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24805701"]])

export default __exports__